import React from 'react';
import CardinalsList from '../components/CardinalsList';
import PageWrapper from '../components/PageWrapper';
import '../styles/CardinauxPage.css';

const CardinauxPage = () => {
  return (
    <PageWrapper pageType="cardinaux">
      <div className="cardinaux-page">
        <div className="page-header">
          <h1>Annuaire des Cardinaux</h1>
          <p>Explorez les profils des cardinaux électeurs du conclave</p>
        </div>
        
        <CardinalsList />
        
        <div className="info-section">
          <h3>À propos du Conclave 2025</h3>
          <p>
            Le Conclave 2025 est l'ensemble des cardinaux de l'Église catholique.
            Sa mission principale est d'élire le nouveau pape lors d'un conclave après la mort ou la renonciation du pape précédent.
            Seuls les cardinaux de moins de 80 ans participent à l'élection papale.
          </p>
        </div>
      </div>
    </PageWrapper>
  );
};

export default CardinauxPage;